import React from 'react'

import './loader.scss'

const Loader = props => {
    const fragment = new Array(8).fill(0).map((a, i) => {
        return (
            <div className="partner-card" key={i}>
                <div className="loader-main">
                    <div className="loader-image"></div>
                    <div className="load-bar loader-title"></div>
                    <div className="load-bar loader-subtitle"></div>
                    <ul>
                        <li className="load-bar"></li>
                        <li className="load-bar"></li>
                        <li className="load-bar"></li>
                        <li className="load-bar"></li>
                        <li className="load-bar"></li>
                    </ul>
                </div>
                <div className="load-bar loader-footer"></div>
            </div>
        )
    })
    return (
        <div className="cards-container loader">
            {fragment}
        </div>
    )
}

export default Loader


// WEBPACK FOOTER //
// ./src/components/shared/loader/index.jsx